if (!customElements.get('card-quick-add')) {
  class CardQuickAdd extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-card-qa-variant-input]');
      this.submitBtn = this.querySelector('[data-card-qa-submit]');

      const variantsScript = this.querySelector('[data-card-qa-variants]');
      try {
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      this.optionsCount = parseInt(this.dataset.optionsCount || '0', 10) || 0;
      this.interactiveOptionsCount = parseInt(
        this.dataset.interactiveOptionsCount || this.dataset.optionsCount || '0',
        10
      ) || 0;

      this._lastVariantId = null;
      this._hoveredOnce = false;

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mouseenter', this.onHover.bind(this));

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      Promise.resolve().then(() => this.onChange(null, true));
    }

    onHover() {
      if (this._hoveredOnce) return;
      this._hoveredOnce = true;
      console.log('[card-quick-add] product hovered', {
        productId: this.dataset.productId,
        formId: this.dataset.formId,
      });
    }

    onSubmit() {
      const positions = this.getSelectedValues();
      console.log('[card-quick-add] add to cart submit', {
        productId: this.dataset.productId,
        formId: this.dataset.formId,
        variantId: this.variantInput ? this.variantInput.value : null,
        options: Object.fromEntries(positions),
      });
    }

    onClick(event) {
      const soldOutWrap = event.target.closest('.is-soldout');
      if (soldOutWrap) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      const label = event.target.closest('label[for]');
      if (!label) return;
      const input = this.querySelector('#' + CSS.escape(label.getAttribute('for')));
      if (!input || input.type !== 'radio') return;
      if (input.disabled) {
        event.preventDefault();
        return;
      }
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    getSelectedValues() {
      const positions = new Map();
      this.querySelectorAll('[data-option-position]').forEach((wrap) => {
        const pos = parseInt(wrap.dataset.optionPosition, 10);
        if (!pos) return;
        let value = null;
        const select = wrap.querySelector('select');
        if (select && select.value) {
          value = select.value;
        } else {
          const checked = wrap.querySelector('input[type="radio"]:checked');
          if (checked) {
            value = checked.value;
          } else {
            const hidden = wrap.querySelector('input[data-option-single-value], input[type="hidden"][name^="options["]');
            if (hidden) value = hidden.value;
          }
        }
        if (value !== null && !positions.has(pos)) {
          positions.set(pos, value);
        }
      });
      return positions;
    }

    findVariant(positions) {
      return this.variants.find((v) =>
        v.options.every((val, i) => positions.get(i + 1) === val)
      );
    }

    updateSelectedLabels(positions) {
      this.querySelectorAll('[data-option-position]').forEach((wrap) => {
        const pos = parseInt(wrap.dataset.optionPosition, 10);
        const target = wrap.querySelector('[data-card-qa-selected-value]');
        if (!target) return;
        target.textContent = positions.get(pos) || '';
      });
    }

    isCandidateAvailable(pos, candidateValue, currentPositions) {
      return this.variants.some((v) => {
        if (!v.available) return false;
        if (v.options[pos - 1] !== candidateValue) return false;
        for (const [otherPos, otherVal] of currentPositions) {
          if (otherPos === pos) continue;
          if (v.options[otherPos - 1] !== otherVal) return false;
        }
        return true;
      });
    }

    updateOptionAvailability(currentPositions) {
      this.querySelectorAll('[data-option-position][data-value]').forEach((wrap) => {
        const pos = parseInt(wrap.dataset.optionPosition, 10);
        if (!pos) return;
        const candidateValue = wrap.dataset.value;
        const available = this.isCandidateAvailable(pos, candidateValue, currentPositions);
        wrap.classList.toggle('is-soldout', !available);
        const input = wrap.querySelector('input[type="radio"]');
        if (input) input.disabled = !available;
      });

      this.querySelectorAll('select[name^="options["]').forEach((select) => {
        const wrap = select.closest('[data-option-position]');
        if (!wrap) return;
        const pos = parseInt(wrap.dataset.optionPosition, 10);
        if (!pos) return;
        Array.from(select.options).forEach((opt) => {
          opt.disabled = !this.isCandidateAvailable(pos, opt.value, currentPositions);
        });
      });
    }

    onChange(_event, initial = false) {
      const positions = this.getSelectedValues();
      const allSelected = positions.size === this.optionsCount && this.optionsCount > 0;
      const variant = allSelected ? this.findVariant(positions) : null;

      if (!initial) {
        console.log('[card-quick-add] variant selected', {
          productId: this.dataset.productId,
          options: Object.fromEntries(positions),
          allSelected: allSelected,
          positionsFilled: positions.size,
          optionsCount: this.optionsCount,
          interactiveOptionsCount: this.interactiveOptionsCount,
          variantResolved: !!variant,
        });
      }

      const newVariantId = variant ? variant.id : null;
      if (newVariantId !== this._lastVariantId) {
        console.log('[card-quick-add] variant change', {
          productId: this.dataset.productId,
          variantId: newVariantId,
          available: variant ? variant.available : null,
          options: Object.fromEntries(positions),
        });
        this._lastVariantId = newVariantId;
      }

      if (variant && this.variantInput) {
        this.variantInput.value = variant.id;
      }

      this.updateSelectedLabels(positions);
      this.updateOptionAvailability(positions);

      if (this.submitBtn) {
        this.submitBtn.disabled = !(variant && variant.available);
      }

      if (
        !initial &&
        this.interactiveOptionsCount === 1 &&
        variant &&
        variant.available
      ) {
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.dispatchEvent(
            new Event('submit', { cancelable: true, bubbles: true })
          );
        }
      }
    }
  }

  customElements.define('card-quick-add', CardQuickAdd);
}
